<script setup>
import { computed } from 'vue';
import { CsIcon } from 'dashboard/components/ui/commslayer';
import { useStore } from 'widget/composables/store';

const emit = defineEmits(['view-article']);

const store = useStore();

const resources = computed(
  () => store.getters['inboxChatResources/getActiveResources']
);

const resourceTitle = resource => {
  if (resource.resource_type === 'Article') {
    return resource.resource.title;
  }
  return resource.resource.name;
};

const onResourceClicked = resource => {
  if (resource.resource_type === 'Article') {
    emit('view-article', resource.resource.api_url);
  }
};

// Fetch resources on mount
store.dispatch(
  'inboxChatResources/get',
  window.chatwootWebChannel.websiteToken
);
</script>

<template>
  <div v-if="resources.length > 0" class="w-full px-3 pt-3">
    <div
      class="rounded-lg bg-brand-surface overflow-hidden"
      style="box-shadow: 0 1.004px 3.012px 0 rgba(20, 4, 40, 0.08)"
    >
      <div
        class="flex w-full flex-col divide-y divide-solid divide-brand-border"
      >
        <div class="px-4 py-2 text-sm font-semibold text-brand-primary">
          {{ $t('RESOURCE_LIST.POPULAR_LINKS') }}
        </div>
        <div
          v-for="resource in resources"
          :key="resource.id"
          class="flex cursor-pointer select-none items-center justify-between px-4 py-2 transition-colors duration-200 hover:text-[var(--brand-text-on-white-background)] hover:bg-c-surface-hover active:bg-c-surface-active"
          @click.prevent="onResourceClicked(resource)"
        >
          <span class="flex-1 text-sm text-current">
            {{ resourceTitle(resource) }}
          </span>
          <CsIcon name="arrow-right" class="ml-3 flex-none text-current" />
        </div>
      </div>
    </div>
  </div>
</template>
